import { cn } from '../lib/cn'

interface PulseDotProps {
  className?: string
  size?: 'xs' | 'sm' | 'md'
  label?: string
}

const sizes = {
  xs: 'w-1.5 h-1.5',
  sm: 'w-2 h-2',
  md: 'w-2.5 h-2.5',
}

export function PulseDot({ className, size = 'sm', label }: PulseDotProps) {
  return (
    <span
      className={cn('pulse-dot inline-block rounded-full bg-primary', sizes[size], className)}
      role={label ? 'status' : undefined}
      aria-label={label}
    />
  )
}
